import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import config from '../../config';
import '../../assets/css/checklistStyles.css'; 
import { FooterMobile } from '../../Layout/FooterMobile';
import Breadcrumbs from '../../components/Breadcrumb';
import { useChecklist } from '../../context/ChecklistContext';
import HeroBanner from '../../components/HeroBanner';
import bannerImage from '../../assets/images/siteImg/checklistImg/BannerImage_SchoolEmail.png';
import emailBasicsImg from '../../assets/images/siteImg/checklistImg/Image_EmailBasics.png';
import emailOptionsImg from '../../assets/images/siteImg/checklistImg/Image_EmailOptions.png';
import AccordionItemChecklist from '../../components/AccordionItemChecklist';
import { getChecklistStatus } from '../../utils/checklistUtils';

const MainChecklistEmailSetup: React.FC = () => {
type ChecklistItem ={
    title: string;
    description: string;
    imageUrl: string;
    linkUrl: string;
    status: string;
}
const { HOME, MAIN_CHECKLIST_DOMAIN, SCHOOL_PREP_CHECKLIST, EMAIL_BASICS, EMAIL_OPTIONS } = config.app.routes;
const { checklistData, checklistTopicStatus } = useChecklist();

// Filter checklist items for the "LEARNING_COACH_LIFE" category
const getChecklistCategoryName = checklistData.filter(
    item => item.checklistCategoryName === "SCHOOL_EMAIL"
);
// Extract unique category name capitalization format
const categoryName = getChecklistCategoryName.length > 0
? getChecklistCategoryName[0].checklistCategoryName
    .toLowerCase()
    .replace(/_/g, " ")
    .split(" ")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
: "School Email";
// Prepare data from both frontend & API to each checklist item
const checklistItems_arr = [
    {
        description: "Get an overview of school email communication and expectations.",
        imageUrl: emailBasicsImg
    },
    {
        description: "Here's a guide on optional ways to set up your email. ",
        imageUrl: emailOptionsImg
    }
];
const checklistWithStatus = getChecklistCategoryName.map((item, index) => ({
    ...checklistItems_arr[index],
    title: item.description,
    checklistId: item.checklistId,
    status: getChecklistStatus(item.checklistId, checklistTopicStatus),
    linkUrl: `${MAIN_CHECKLIST_DOMAIN}/${item.checklistName.toLowerCase().replace(/_/g, '-')}`,
}));
const breadcrumbItems = [
    { label: "Home", path: HOME },
    { label: "School Prep Checklist", path: SCHOOL_PREP_CHECKLIST },
    { label: categoryName }, 
];
return (
<div className="home-layout">
    <div className="sidebar-wrapper">
        <Sidebar />
    </div>
    <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
                <Header />
                <main id="main" role="main">
                <div className="main-content" id="email-setup-category">
                    <div className="row">
                        <div className="col-12">
                            <Breadcrumbs items={breadcrumbItems} />
                        </div>
                    </div>

                    <HeroBanner
                        title={categoryName}
                        subtitle="Let's connect!"
                        imageUrl={bannerImage}
                        altText={categoryName}
                        customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                    />

                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                        <div className="wp-block-k12-section container-fluid  bg-transparent">
                            <div className="row">
                                <div className="col-12 g-0">
                                    <div className="wp-block-k12-checklist-grid container-fluid">
                                        <div className="row">
                                            <div className="col-12">
                                            <ul>
                                                {checklistWithStatus.map((item: ChecklistItem, index: number) => (
                                                    <AccordionItemChecklist
                                                    key={index}
                                                    title={item.title}
                                                    description={item.description}
                                                    imageUrl={item.imageUrl}
                                                    linkUrl={item.linkUrl}
                                                    status={item.status}
                                                    />
                                                ))}
                                            </ul>
                                            <ul className="d-none">
                                                <a className="checklist-link" href={EMAIL_BASICS}>
                                                    <li className="checklist-item">
                                                        <div className="checklist-image">
                                                            <img
                                                                width="400"
                                                                height="360"
                                                                src="https://welcome.k12.com/wp-content/uploads/2024/05/Image_EmailOptions.png"
                                                                className="img-fluid wp-post-image"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="checklist-body">
                                                            <h2>Email Basics</h2>
                                                            <p className="size-large">Get an overview of school email communication and expectations.&nbsp;</p>
                                                        </div>
                                                        <div className="checklist-status">
                                                            <span className="pill">Completed</span>
                                                        </div>
                                                    </li>
                                                </a>
                                                <a className="checklist-link" href={EMAIL_OPTIONS}>
                                                    <li className="checklist-item">
                                                        <div className="checklist-image">
                                                            <img
                                                                width="400"
                                                                height="354"
                                                                src="https://welcome.k12.com/wp-content/uploads/2024/05/Card-Icons-2.png"
                                                                className="img-fluid wp-post-image"
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="checklist-body">
                                                            <h2>Email Options</h2>
                                                            <p className="size-large">Here's a guide on optional ways to set up your email.&nbsp;</p>
                                                        </div>
                                                        <div className="checklist-status">
                                                            <span className="pill">Begin Topic</span>
                                                        </div>
                                                    </li>
                                                </a>
                                            </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                    </div>
                    </div>
                </div>
                </main>
            </div>
        </div>
    </div>
    <FooterMobile />
</div>
);
};

export default MainChecklistEmailSetup;
